import { Injectable } from "@angular/core";
import { StudentBooking } from "../../student-bookings";

@Injectable({
  providedIn: 'root'
})
export class LearnerJourneyHelperService {
  public studentBookingData: StudentBooking;

  public setStudentBookingData(booking: StudentBooking) {
    this.studentBookingData = booking;
  }

  public getStudentBookingData() : StudentBooking {
    return this.studentBookingData;
  }

}
